import { useEffect, useState, useRef } from "react";
import styles from "./index.module.less";
import {
  Tabs,
  TabHeader,
  TabDropdownItem,
  ButtonField,
  Iconsvg,
} from "@wk/components-react16";

import { handleDownFile } from "@/services/manage";
import banner4 from "@/assets/img/banner4.png";

const Template = () => {
  // "管理案例", "教学案例", "临床案例", "科研案例", "住培案例"
  const tabsList = [
    {
      label: "临床案例",
      list: [
        {
          label: "抽丝剥茧，网络“导师”",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E4%B8%B4%E5%BA%8A--%E6%8A%BD%E4%B8%9D%E5%89%A5%E8%8C%A7%EF%BC%8C%E7%BD%91%E7%BB%9C%E2%80%9C%E5%AF%BC%E5%B8%88%E2%80%9D.pdf",
        },
        {
          label: "一面天堂，一面地狱，半身感染为哪般？UpToDate循证诊疗思考",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E4%B8%B4%E5%BA%8A--%E4%B8%80%E9%9D%A2%E5%A4%A9%E5%A0%82%EF%BC%8C%E4%B8%80%E9%9D%A2%E5%9C%B0%E7%8B%B1%EF%BC%8C%E5%8D%8A%E8%BA%AB%E6%84%9F%E6%9F%93%E4%B8%BA%E5%93%AA%E8%88%AC%EF%BC%9Fup%20to%20date%E5%BE%AA%E8%AF%81%E8%AF%8A%E7%96%97%E6%80%9D%E8%80%83.pdf",
        },
        {
          label: "隐藏在脓毒症背后的“凶手”——1例弥漫大B淋巴瘤的确诊之路",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E4%B8%B4%E5%BA%8A--%E9%9A%90%E8%97%8F%E5%9C%A8%E8%84%93%E6%AF%92%E7%97%87%E8%83%8C%E5%90%8E%E7%9A%84%E2%80%9C%E5%87%B6%E6%89%8B%E2%80%9D%E2%80%94%E2%80%941%E4%BE%8B%E5%BC%A5%E6%BC%AB%E5%A4%A7B%E6%B7%8B%E5%B7%B4%E7%98%A4%E7%9A%84%E7%A1%AE%E8%AF%8A%E4%B9%8B%E8%B7%AF.pdf",
        },
      ],
    },
    {
      label: "住培案例",
      list: [
        {
          label:
            "“阴”何而起 · “啡”比寻常 —UpToDate辅助诊治阴蒂肥大伴皮肤咖啡斑1例",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E4%BD%8F%E5%9F%B9--%E2%80%9C%E9%98%B4%E2%80%9D%E4%BD%95%E8%80%8C%E8%B5%B7%20%C2%B7%20%E2%80%9C%E5%95%A1%E2%80%9D%E6%AF%94%E5%AF%BB%E5%B8%B8%E2%80%94%20UpToDate%E8%BE%85%E5%8A%A9%E8%AF%8A%E6%B2%BB%E9%98%B4%E8%92%82%E8%82%A5%E5%A4%A7%E4%BC%B4%E7%9A%AE%E8%82%A4%E5%92%96%E5%95%A1%E6%96%911%E4%BE%8B.pdf",
        },

        {
          label: "去伪存真之死里逃生 月经紊乱背后的真相",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E4%BD%8F%E5%9F%B9--%E5%8E%BB%E4%BC%AA%E5%AD%98%E7%9C%9F%E4%B9%8B%E6%AD%BB%E9%87%8C%E9%80%83%E7%94%9F%20%E6%9C%88%E7%BB%8F%E7%B4%8A%E4%B9%B1%E8%83%8C%E5%90%8E%E7%9A%84%E7%9C%9F%E7%9B%B8.pdf",
        },

        {
          label: "走近科学之动脉导管如何关闭 —UpToDate临床揭秘",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E4%BD%8F%E5%9F%B9--%E8%B5%B0%E8%BF%91%E7%A7%91%E5%AD%A6%E4%B9%8B%E5%8A%A8%E8%84%89%E5%AF%BC%E7%AE%A1%E5%A6%82%E4%BD%95%E5%85%B3%E9%97%AD%20%E2%80%94Up%20To%20Date%E4%B8%B4%E5%BA%8A%E6%8F%AD%E7%A7%98.pdf",
        },
      ],
    },
    {
      label: "教学案例",
      list: [
        {
          label: "UpToDate辅助重症肺炎教学查房教案ITEACHER培训课程",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E6%95%99%E5%AD%A6--UpToDate%E8%BE%85%E5%8A%A9%E9%87%8D%E7%97%87%E8%82%BA%E7%82%8E%E6%95%99%E5%AD%A6%E6%9F%A5%E6%88%BF%E6%95%99%E6%A1%88ITEACHER%E5%9F%B9%E8%AE%AD%E8%AF%BE%E7%A8%8B.pdf",
        },
        {
          label: "UpToDate赋能教学：妊娠期糖尿病分娩导航的临床教学",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E6%95%99%E5%AD%A6--UpToDate%E8%B5%8B%E8%83%BD%E6%95%99%E5%AD%A6%EF%BC%9A%E5%A6%8A%E5%A8%A0%E6%9C%9F%E7%B3%96%E5%B0%BF%E7%97%85%E5%88%86%E5%A8%A9%E5%AF%BC%E8%88%AA%E7%9A%84%E4%B8%B4%E5%BA%8A%E6%95%99%E5%AD%A6.pdf",
        },
      ],
    },
    {
      label: "科研案例",
      list: [
        {
          label: "PHV置换术后围产期抗凝方案的制定 ——基于UpToDate的临床研究",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E7%A7%91%E7%A0%94--PHV%E7%BD%AE%E6%8D%A2%E6%9C%AF%E5%90%8E%E5%9B%B4%E4%BA%A7%E6%9C%9F%E6%8A%97%E5%87%9D%E6%96%B9%E6%A1%88%E7%9A%84%E5%88%B6%E5%AE%9A%20%E2%80%94%E2%80%94%E5%9F%BA%E4%BA%8EUpToDate%E7%9A%84%E4%B8%B4%E5%BA%8A%E7%A0%94%E7%A9%B6.pdf",
        },
        {
          label: "UpToDate辅助科研选题",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E7%A7%91%E7%A0%94--UpToDate%E8%BE%85%E5%8A%A9%E7%A7%91%E7%A0%94%E9%80%89%E9%A2%98.pdf",
        },
        {
          label: "细胞周期阻滞生物标志物预测老年急性肾损伤",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E7%A7%91%E7%A0%94--%E7%BB%86%E8%83%9E%E5%91%A8%E6%9C%9F%E9%98%BB%E6%BB%9E%E7%94%9F%E7%89%A9%E6%A0%87%E5%BF%97%E7%89%A9%E9%A2%84%E6%B5%8B%E8%80%81%E5%B9%B4%E6%80%A5%E6%80%A7%E8%82%BE%E6%8D%9F%E4%BC%A4.pdf",
        },
        {
          label: "终板重塑诱发腰痛的秘密-取之临床、用之临床的科研之旅",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E7%A7%91%E7%A0%94--%E7%BB%88%E6%9D%BF%E9%87%8D%E5%A1%91%E8%AF%B1%E5%8F%91%E8%85%B0%E7%97%9B%E7%9A%84%E7%A7%98%E5%AF%86-%E5%8F%96%E4%B9%8B%E4%B8%B4%E5%BA%8A%E3%80%81%E7%94%A8%E4%B9%8B%E4%B8%B4%E5%BA%8A%E7%9A%84%E7%A7%91%E7%A0%94%E4%B9%8B%E6%97%85.pdf",
        },
      ],
    },
    {
      label: "管理案例",
      list: [
        {
          label: "精益管理实践与质量持续改进",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E7%AE%A1%E7%90%86--%E7%B2%BE%E7%9B%8A%E7%AE%A1%E7%90%86%E5%AE%9E%E8%B7%B5%E4%B8%8E%E8%B4%A8%E9%87%8F%E6%8C%81%E7%BB%AD%E6%94%B9%E8%BF%9B.pdf",
        },
        {
          label: "武汉同济医院：UTD全流程管理经验分享",
          url: "https://uptodatestatic.oss-cn-beijing.aliyuncs.com/template/2025template/%E7%AE%A1%E7%90%86--%E6%AD%A6%E6%B1%89%E5%90%8C%E6%B5%8E%E5%8C%BB%E9%99%A2%EF%BC%9AUTD%E5%85%A8%E6%B5%81%E7%A8%8B%E7%AE%A1%E7%90%86%E7%BB%8F%E9%AA%8C%E5%88%86%E4%BA%AB.pdf",
        },
      ],
    },
  ];

  const tabsLoadingRef = useRef({});
  const [isLoading, setIsLoading] = useState();

  const [selectedTab, setSelectedTab] = useState(0);

  const logUserRequest = (event) => {
    setSelectedTab(event);
  };

  // 下载
  const download = async (url, name) => {
    tabsLoadingRef.current = { ...tabsLoadingRef.current, [name]: true };
    setIsLoading(name);
    try {
      await handleDownFile(url, name);
    } catch (error) {
      console.log(error);
    }
    tabsLoadingRef.current = { ...tabsLoadingRef.current, [name]: false };
    setIsLoading(`${name}下载完成`);
  };

  return (
    <div className={styles["template-box"]}>
      <div className="img-fluid">
        <img src={banner4} alt="" />
      </div>
      <div className="tabs-box">
        <Tabs
          mode="default"
          selectedTab={selectedTab}
          onUserRequest={(event) => logUserRequest(event)}
        >
          {tabsList.map((item, index) => {
            return (
              <div key={index}>
                <TabHeader slot="tabHeader">{item.label}</TabHeader>
                <TabDropdownItem slot="tabDropdownItem">
                  {item.label}
                </TabDropdownItem>
              </div>
            );
          })}
        </Tabs>
      </div>

      <div className="content-box">
        {tabsList[selectedTab].list.map((item, index) => {
          return (
            <div key={index}>
              <div
                className="title"
                onClick={() => {
                  const domain = window.location.origin;
                  window.open(`${domain}/viewer.html?file=${item.url}`);
                }}
              >
                {item.label}
              </div>
              <div className="btn-box">
                <ButtonField iconPosition={"right"} mode={"ghost"}>
                  <button
                    type="button"
                    onClick={() => {
                      const domain = window.location.origin;
                      window.open(`${domain}/viewer.html?file=${item.url}`);
                    }}
                  >
                    查看
                    <Iconsvg name="arrow-right"></Iconsvg>
                  </button>
                </ButtonField>

                <ButtonField iconPosition={"right"} mode={"ghost"}>
                  <button
                    type="button"
                    onClick={() => download(item.url, item.label)}
                    disabled={tabsLoadingRef.current[item.label]}
                  >
                    下载
                    {tabsLoadingRef.current[item.label] ? (
                      <Iconsvg name="spinner-alt" isSpin></Iconsvg>
                    ) : (
                      <Iconsvg name="arrow-right"></Iconsvg>
                    )}
                  </button>
                </ButtonField>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Template;
